import React from 'react';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useQualificationStructureUrl } from '../routing';
import ViewQualificationStructureComparisonBreadcrumbs from './QualificationStructureComparisonBreadcrumbs';

const ViewQualificationStructureBuilderBreadcrumbs = ({ children }: { children?: React.ReactNode }) => {
  const { getBuilderUrl } = useQualificationStructureUrl();
  return (
    <ViewQualificationStructureComparisonBreadcrumbs>
      <SingleBreadcrumbItem entity="Builder" link={getBuilderUrl} />
      {children}
    </ViewQualificationStructureComparisonBreadcrumbs>
  );
};

export default ViewQualificationStructureBuilderBreadcrumbs;
